export const server = `${window.app && window.app.env.API_URL}/api`
